//import Profiles from './screens/profiles.vue';
const Profiles = () => import('./screens/profiles.vue')

//import Users from './screens/index.vue';
const Users = () => import('./screens/index.vue')

//import UpdateCurrentUser from './screens/update-current-user.vue';
const UpdateCurrentUser = () => import('./screens/update-current-user.vue')

import { checkUserPermissions } from '@/services/auth';
import { PERMISSIONS_KEYS } from '@/settings/consts/permissions';

const usersRoutes = [];

usersRoutes.push({
  path: '/atualizar-meus-dados',
  name: 'Atualiza Meus Dados',
  component: UpdateCurrentUser,
  meta: {
    requiresAuth: true,
    hideFromMenu: true,
  },
});

if (
  checkUserPermissions([
    PERMISSIONS_KEYS.USER_VIEW,
    PERMISSIONS_KEYS.USER_INSERT,
    PERMISSIONS_KEYS.USER_EDIT,
    PERMISSIONS_KEYS.USER_DELETE,
  ])
) {
  usersRoutes.push({
    path: '/usuarios',
    name: 'Administração|Usuário',
    component: Users,
    meta: {
      icon: 'account_circle',
      requiresAuth: true,
    },
  });
}

if (
  checkUserPermissions([
    PERMISSIONS_KEYS.USER_VIEW,
    PERMISSIONS_KEYS.USER_INSERT,
    PERMISSIONS_KEYS.USER_EDIT,
    PERMISSIONS_KEYS.USER_DELETE,
  ])
) {
  usersRoutes.push({
    path: '/usuarios/analises/docs',
    name: 'Administração|Análise Usuário',
    component: Users,
    meta: {     
      requiresAuth: true,
      hideFromMenu: true,
    },
  });
}

if (
  checkUserPermissions([
    PERMISSIONS_KEYS.PROFILE_VIEW,
    PERMISSIONS_KEYS.PROFILE_INSERT,
    PERMISSIONS_KEYS.PROFILE_EDIT,
  ])
) {
  usersRoutes.push({
    path: '/usuarios/perfis',
    name: 'Administração|Perfil de Acesso',
    component: Profiles,
    meta: {
      icon: 'account_circle',
      requiresAuth: true,
    },
  });
}

export { usersRoutes };

